import React from "react"
import { Form, Message } from "semantic-ui-react"

const SelectToposProtimisis = (props) => {
  const {
    error,
    label,
    choice,
    perifereies,
    epithymiaMetathesis,
    onChange,
    selectedPerifereia,
    selectedDimos,
    logoiMetathesis,
    selectedLogos,
    clearValues,
    otherSelectedDimoi
  } = props

  let dimoi = []
  if (selectedPerifereia) {
    const tmp = perifereies.find((p) => p.value === selectedPerifereia)
    dimoi = tmp.items.filter((item) => !otherSelectedDimoi.includes(item.value))
  }

  let message
  if (selectedDimos) {
    const dimos = dimoi.find((p) => p.value === selectedDimos)
    if (dimos && dimos.message && dimos.message.length > 0) {
      message = (
        <Message positive>
          <Message.Header>Μονάδες στο δήμο {selectedDimos.text}</Message.Header>
          {dimos.message}
        </Message>
      )
    } else {
      message = (
        <Message color="yellow">
          Δεν υπάρχουν μονάδες στο δήμο {selectedDimos.text}
        </Message>
      )
    }
  }

  return (
    <>
      <div>{label}</div>
      {epithymiaMetathesis ? (
        <Form.Group widths="equal">
          <Form.Select
            error={error}
            name={"selectedPerifereia" + choice}
            options={perifereies}
            placeholder="Περιφερειακή ενότητα"
            onChange={onChange}
            value={selectedPerifereia}
            selectOnBlur={false}
          />
          <Form.Select
            error={error}
            name={"selectedDimos" + choice}
            options={dimoi}
            placeholder="Δήμος"
            onChange={onChange}
            value={selectedDimos}
            selectOnBlur={false}
          />
          <Form.Select
            error={error}
            name={"selectedLogos" + choice}
            options={logoiMetathesis}
            placeholder="Λόγος (Σύμφωνα με ν.3883/2010 αρθ.1 παρ ιε)"
            onChange={onChange}
            value={selectedLogos}
            selectOnBlur={false}
          />
          {(selectedPerifereia || selectedDimos || selectedLogos) && (
            <Form.Button
              fluid
              icon="undo"
              onClick={() => clearValues(choice)}
            />
          )}
        </Form.Group>
      ) : (
        <>
          <br /> <i style={{ color: "gray" }}>Τρέχουσα επιλογή</i>
          <br />
          <br />
        </>
      )}
      {message}
    </>
  )
}

export default SelectToposProtimisis
